import { render } from "./UploadTemplateMessage.vue?vue&type=template&id=cf5846dc&scoped=true&bindings={}"
import script from "./UploadTemplateMessage.vue?vue&type=script&lang=js"
export * from "./UploadTemplateMessage.vue?vue&type=script&lang=js"

import "./UploadTemplateMessage.vue?vue&type=style&index=0&id=cf5846dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cf5846dc"

export default script